<template>
    <div>
        <b-form-input 
            :value="inner_value"
            :state="state"
            :size="size"
            :disabled="disabled"
            :placeholder="placeholder"
            @input="setValue"
            @focus.native="inputFocus"
            @blur.native="inputBlur"
            @keydown.native.up="previous"
            @keydown.native.down="next"
            @keydown.native.enter="select(active_index)"
            @keydown.native.esc.stop="active_index = -1"
            :aria-describedby="feedback"
        ></b-form-input>
        <b-form-invalid-feedback :id="feedback">Campo Obrigatório.</b-form-invalid-feedback>

        <div class="list-box">
            <b-list-group v-show="show_list" >
                <b-list-group-item  v-for="(item, i) in items" :key="item[keyId]" button @click="select(i)" :active="i === active_index" v-html="item[keyText]"></b-list-group-item>
            </b-list-group>
        </div>
     </div>
</template>

<script>

import { debounce } from 'lodash';

export default {
    props: {
        value: String,
        state: { type: Boolean, default: null },
        dados: {
            type: Array,
            default: () => []
        },
        urlDados: String,
        functionJquery: Function,
        function: Function,
        keyText: {
            type: String,
            default: 'text'
        },
        keyId: {
            type: String,
            default: 'value'
        },
        //aplicável somente se os dados foram fornecidos via parâmetro 'dados' (buscas por URL e funções seguem a própria lógica)
        ignoreCase: {
            type: Boolean,
            default: true
        },
        //Tamanho mínimo da string de busca (começa a busca somente a partir desse tamanho)
        minSearchSize: {
            type: Number,
            default: 1
        },
        //Ativa automaticamente o primeiro item da lista sempre que ela é atualizada
        activeFirst: {
            type: Boolean,
            default: true
        },
        //Se deve permitir que o usuário insira um texto que não foi encontrado na lista
        allowAny: {
            type: Boolean,
            default: true
        },
        size:{
            type: String,
            default: 'md'
        },
        disabled:{
            type: Boolean,
            default: false
        },
        feedback:{
            type: String,
            default: ''
        },
        placeholder:{
            type: String,
            default: ''
        },      
    },
    data() {
        return {
            items: [],
            active_index: -1,
            selected_item: -1,
            focused: false,
            show_list: false,
            inner_value: this.value,
            blur_timeout: undefined,
        }
    },
    watch: {
        value() {
            this.inner_value = this.value;
        },
        items() {
            //sempre que a lista é atualizada, desmarca o item selecionado anteriormente
            this.active_index = this.activeFirst ? 0 : -1;
        },
        focused(valor) {
            if(!valor) $(this.$el).find('input').trigger('blur');
            else this.active_index = this.activeFirst ? 0 : -1;
        },
    },
    methods: {
        setValue(valor) {
            this.inner_value = valor;
            //se tinha selecionado um item da lista, mas mudou o texto do campo para um valor diferente do texto desse item
            if(this.items[this.selected_item] && this.items[this.selected_item][this.keyText] !== valor) {
                this.selected_item = -1;
            }
            this.$emit('input', valor);
            this.search(valor);
        },
        /**
         * Emite o último item selecionado
         * @param {Number} i índice do item selecionado na lista. default = -1 = não selecionar da lista.
        */
        selectItem(i = -1) {
            let item = (i!==-1 && this.items[i]) 
                //selecionou um item da lista
                ? {...this.items[i]}
                //informou texto arbitrário
                : {[this.keyText]: this.allowAny ? this.inner_value : ''};

            this.inner_value = item.text;

            //this.selected_item = item;
            this.selected_item = i;

            this.$emit('input', item.text);
            this.$emit('selected', item);
        },
        /**
         * Consulta os itens que contêm o texto pesquisado.
         * Utiliza a função debounce do lodash para evitar chamadas consecutivas num curto período.
        */
        search: debounce(function(str) {

            if(this.focused)
            {
                if(str && str.length >= this.minSearchSize)
                {
                    if(this.functionJquery) {
                        this.functionJquery(str)
                        .done(response => { this.items = response; }) 
                        .fail();
                    } else if(this.function) {
                        this.function(str)
                        .then(response => { this.items = response.data.data; }) 
                        .catch();
                    } else if(this.urlDados) {
                        this.$api.
                        getFonteDados(this.urlDados, str, false)
                        .then(response => { this.items = response; })
                        .catch();
                    } else {
                        if(this.ignoreCase) {
                            str = str.toUpperCase();
                            this.items = this.dados.filter(item => {
                                return item[this.keyText].toUpperCase().indexOf(str) !== -1;
                            });
                        } else {
                            this.items = this.dados.filter(item => {
                                return item[this.keyText].indexOf(str) !== -1;
                            });
                        }
                    }
                } else {
                    this.items = [];
                }
            }
        }, 500),
        /**
         * Seleciona o item especificado pelo índice
         * @param {number} i índice do item
         * 
        */
        select(i) {
            this.selectItem(i);
            this.focused = false;
        },
        /**
         * Atrasa o evento blur do input interno.
        */
        inputBlur() {
            //previne dois disparos sequenciais de blur
            if(!this.blur_timeout) {
                this.blur_timeout = window.setTimeout(() => {
                    this.focused = false;
                    this.show_list = false;
                    this.blur_timeout = undefined;
                    //Se não selecionou valor na lista
                    if(this.selected_item === -1)
                        this.selectItem();
                    //this.items = [];
                }, 200);
            }
        },
        inputFocus() {
            this.focused = true;
            this.show_list = true;
            if(this.blur_timeout) {
                window.clearTimeout(this.blur_timeout);
                this.blur_timeout = undefined;
            }
        },
        /**
        * Marca o próximo item da lista. Não seleciona, apenas marca para seleção.
        */
        next() {
            this.active_index = (this.active_index+1) % this.items.length;
        },
        /**
        * Marca o item anterior da lista. Não seleciona, apenas marca para seleção.
        */
        previous() {
            let atual = (this.active_index < 1) ? this.items.length : this.active_index;
            this.active_index = atual -1;
        }
    },
}
</script>

<style scoped>
.list-box {
    height: 0;
    overflow: visible;
}
.list-box .list-group-item {
    z-index: 1051;
}
</style>